import i18n from "./i18n"; // adjust path if needed

const changeLanguage = (lng = "en") => {
  i18n.changeLanguage(lng);
  localStorage.setItem("i18nextLng", lng);
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
  document.documentElement.lang = lng;
};

export default changeLanguage;
